function Phone() {
  return (
    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.4805 7.80859L10.0117 9.78125C9.95312 10.0742 9.71875 10.2695 9.42578 10.2695C4.50391 10.25 0.5 6.24609 0.5 1.32422C0.5 1.03125 0.675781 0.796875 0.96875 0.738281L2.94141 0.269531C3.21484 0.210938 3.50781 0.367188 3.625 0.621094L4.54297 2.75C4.64062 3.00391 4.58203 3.29688 4.36719 3.45312L3.3125 4.3125C3.97656 5.66016 5.07031 6.75391 6.4375 7.41797L7.29688 6.36328C7.45312 6.16797 7.74609 6.08984 8 6.1875L10.1289 7.10547C10.3828 7.24219 10.5391 7.53516 10.4805 7.80859Z"
        fill="#FFBF17"
      />
    </svg>
  );
}

export default Phone;
